(ns manage.poi.shared
  (:require ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [uix.core :refer [$ defui] :as uix]))

(defn use-cursor-pagination []
  (let [[cursor set-cursor] (uix/use-state nil)
        [offset set-offset] (uix/use-state 0)
        reset (uix/use-callback (fn [] (set-cursor nil) (set-offset 0)) [])]
    {:cursor cursor
     :reset  reset
     :page-props
     (fn [page-data]
       (let [items       (:items page-data)
             total       (:total page-data)
             per-page    (:per-page page-data)
             next-cursor (:next-cursor page-data)
             prev-cursor (:prev-cursor page-data)
             item-count  (count items)
             start       (when (pos? item-count) (inc offset))
             end         (when (pos? item-count) (+ offset item-count))]
         {:items items
          :total total
          :pagination-props
          {:prev-cursor prev-cursor
           :next-cursor next-cursor
           :start       start
           :end         end
           :total       total
           :on-prev #(do (set-cursor {:page-before prev-cursor})
                         (set-offset (max 0 (- offset per-page))))
           :on-next #(do (set-cursor {:page-after next-cursor})
                         (set-offset (+ offset item-count)))}}))}))

(defui cursor-pagination [{:keys [prev-cursor next-cursor on-prev on-next start end total]}]
  ($ Stack {:direction "row" :justifyContent "flex-end" :alignItems "center" :p 1 :spacing 1}
     (when (and start end total (pos? total))
       ($ Typography {:variant "body2" :color "text.secondary"}
          (str start "–" end " of " total)))
     ($ IconButton {:onClick on-prev :disabled (nil? prev-cursor) :size "small"} "<")
     ($ IconButton {:onClick on-next :disabled (nil? next-cursor) :size "small"} ">")))

(defn render-label-chips [^js params]
  (let [labels (->clj (.-value params))]
    ($ :div {:style {:overflow "hidden" :position "relative" :width "100%"
                     :maskImage "linear-gradient(to right, black 85%, transparent)"
                     :WebkitMaskImage "linear-gradient(to right, black 85%, transparent)"}}
       ($ Stack {:direction "row" :spacing 0.5 :alignItems "center"
                 :sx #js {:flexWrap "nowrap"}}
          (for [lbl labels]
            ($ Chip {:key lbl :label lbl :size "small"
                     :sx #js {:backgroundColor "#e0e0e0" :color "#212121"}}))))))

(defn delete-action-column [on-delete row->delete-params]
  #js {:field "actions"
       :headerName ""
       :width 50
       :sortable false
       :disableColumnMenu true
       :renderCell (fn [^js params]
                     (let [row (->clj (.-row params))]
                       ($ IconButton {:size "small"
                                      :onClick (fn [^js e]
                                                 (.stopPropagation e)
                                                 (on-delete (row->delete-params row)))}
                          ($ Icon "delete"))))})
